//个人中心
const userBox          = () => import('@/components/user/userBox');
const userSetting      = () => import('@/components/user/userSetting');

/* 修改密码 */
const modify_password  = () => import('@/components/user/modify/password');

/* 修改手机号 */
const modify_mobile    = () => import('@/components/user/modify/mobile');

/* 修改邮箱 */
const modify_email     = () => import('@/components/user/modify/email');
 


export default{
    path: '/userBox',
    name: 'userBox',
    component: userBox,
    children: [
        { path: 'userSetting', component: userSetting, name: 'userSetting' },

        /* 敏感路由 只定义path */
        { path: 'modify/password', component: modify_password },   
        { path: 'modify/mobile', component: modify_mobile },   
        { path: 'modify/email', component: modify_email },   
    ]
}



// WEBPACK FOOTER //
// ./src/router/routes/user.js